<template>
  <div class="row">

    <div class="col-12 px-0">
      <h1 class="d-flex align-items-center">
        <span class="icon mr-2 icon-schliesszeiten" aria-hidden="true"></span>
        {{ $t('views.holidayEdit.title') }}
      </h1>
    </div>

    <link-back to="/holiday-list" i18nMessage="common.backToOverview" />

    <loading-container :state="state" errorLinkTo="/holiday-list">
      <form @submit.prevent="onSubmit()" class="mt-3">
        <control-input
          i18nLabel="common.holiday.name"
          :validation="v$.name"
          v-model="name"
        />
        <control-input
          i18nLabel="common.holiday.description"
          :validation="v$.description"
          v-model="description"
        />
        <control-date
          i18nLabel="common.holiday.date"
          :validation="v$.date"
          v-model="date"
        />

        <div class="row mx-auto mt-4">
          <div class="col-12 col-md-4 offset-md-2 col-lg-3 offset-lg-3 mt-1 px-xs-0">
            <button-cancel v-on:clicked="back()" class="btn-w-100" />
          </div>
          <div class="col-12 col-md-4 col-lg-3 mt-1 px-xs-0">
            <button-save i18nMessage="views.holidayEdit.save" class="btn-w-100" />
          </div>
        </div>

      </form>
    </loading-container>
  </div>
</template>

<script lang="ts">
import ControlDate from '@/components/controls/ControlDate.vue'
import ControlInput from '@/components/controls/ControlInput.vue'
import ButtonCancel from '@/components/interaction/ButtonCancel.vue'
import ButtonSave from '@/components/interaction/ButtonSave.vue'
import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import { Holiday } from '@/generated/openapi'
import LoadingMixin from '@/mixins/LoadingMixin'
import { adminService } from '@/services/adminService'
import { now } from '@/utils/dateTimeUtils'
import { validateAndFocusInvalid } from '@/utils/formUtils'
import { LoadingState } from '@/utils/loadingUtils'
import { urlParamString } from '@/utils/navigationUtils'
import { createHolidayValidations } from '@/utils/validationUtils'
import { useVuelidate } from '@vuelidate/core'
import { defineComponent } from 'vue'
import LinkBack from '@/components/interaction/LinkBack.vue';
import { InfoPopupBase, InfoPopupType } from '@/models/InfoPopupData'


export default defineComponent({
  name: 'HolidayEdit',
  mixins: [
    LoadingMixin
  ],
  components: {
    LoadingContainer,
    ControlInput,
    ControlDate,
    ButtonSave,
    ButtonCancel,
    LinkBack
  },
  created() {
    this.id = urlParamString(this.$route, 'id')
    adminService.getHoliday(this.id)
      .then(holiday => {
        this.name = holiday.name || ''
        this.description = holiday.description || ''
        this.date = holiday.date || ''
        this.version = holiday.version
        this.state = LoadingState.success
      }).catch(this.handleError)
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      name: '',
      description: '',
      date: now().toISODate(),
      version: 0,
      id: ''
    }
  },
  validations() {
    return createHolidayValidations()
  },
  methods: {
    back() {
      this.$router.push('/holiday-list')
    },
    onSubmit() {
      validateAndFocusInvalid(this.v$, this.$el).then(this.updateHoliday)
    },
    asHoliday(): Holiday {
      return {
        id: this.id,
        version: this.version,
        name: this.name,
        description: this.description || undefined,
        date: this.date
      }
    },
    updateHoliday() {
      this.state = LoadingState.loading;
      adminService.updateHoliday(this.asHoliday()).then(() => {
        this.$store.commit('addInfoPopup', {
          title: this.$t('views.holidayEdit.infopopup.success'),
          type: InfoPopupType.info
        } as InfoPopupBase)
        this.$router.push('/holiday-list')
      }).catch(() => {
        this.state = LoadingState.error;
      }).catch(this.handleError)
    }
  }
});
</script>
